import React, { useState } from 'react';
import { Drawer, Link } from 'tdesign-react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import ModalHeader from '@/components/Header/Modal';
import Logs from '@/pages/Cluster/components/Logs';
import { getCurrentCluster } from '@/pages/Layout/MenuLayout/CulsterAddon';

function Detail({ detail, clusterName, currentCluster }) {
  const [visible, setVisible] = useState(false);
  const handleClose = () => setVisible(false);

  return (
    <>
      {currentCluster?.deployEnv === 'vm' ? (
        <Link theme='primary' onClick={() => setVisible(true)}>
          {detail.host}
        </Link>
      ) : (
        detail.host
      )}

      <Drawer
        visible={visible}
        destroyOnClose
        size={1000}
        header={
          <ModalHeader tags={[clusterName, `${detail.host}:${detail.port}`, detail.version]}>
            Zookeeper
          </ModalHeader>
        }
        footer={null}
        onOverlayClick={handleClose}
        onClose={handleClose}
      >
        <Body>
          <Title>日志</Title>
          <Logs host={detail.host} type='pulsar-zookeeper' />
        </Body>
      </Drawer>
    </>
  );
}

export default connect((state) => ({
  currentCluster: getCurrentCluster(state.cluster.allList),
}))(Detail);

const Body = styled.div`
  margin-top: -10px;
`;

const Title = styled.div`
  font-size: 14px;
  color: var(--td-font-gray-1);
  font-weight: bold;
  line-height: 3.8em;
  margin-bottom: -60px;
  padding-left: 4px;
`;
